<template lang="pug">
v-list
  .title Telegram ссылки
  v-list-item(
    v-for="(l, idx) in telegram" :key="l.id"
    :href="l.link"
    target="_blank"
  )
    v-list-item-avatar(color="grey lighten-2" size="28") {{  idx + 1 }}
    v-list-item-title {{ l.name }}
</template>

<script>
export default {
  name: 'ContentLinks',
  props: {
    telegram: { type: Array, default: () => [] },
  },
};
</script>
